import React, { useContext, createContext, useEffect, useState } from 'react';
import OpenAI from 'openai';
import { ManagerContext } from './ManagerContext';
import { zodResponseFormat } from "openai/helpers/zod";
import { set, z } from "zod";
import { fetch } from 'openai/_shims/index.mjs';
import { FlareSharp } from '@mui/icons-material';
// import org.json.JSONObject

export const OpenAiContext = createContext(null);

// Hook do korzystania z WebSocketContext
export function useWS() {
    return useContext(OpenAiContext);
}

export const OpenAIProvider = ({ children }) => {
    const { 
        currentUser, 
        sendTask, 
        connectionState, 
        openaiApiKey, 
        isInit, 
        openBackDrop, closeBackDrop } = useContext(ManagerContext);
    const openai = new OpenAI({dangerouslyAllowBrowser: true, apiKey: openaiApiKey});
    const [ messages, setMessages ] = useState([]);
    const [ threadMessages , setThreadMessages  ] = useState();
    const [stream, setStream] = React.useState(null);
    const [config, setConfig] = useState({
        repeat: false,
    });


    const chatDef = {
        assistant_id: null,
        run_id: null,
        activeThread: null,
        linearThread:null,
        threads: [],
        }
    
    const [ chat, setChat ] = useState(chatDef);
    const [ forwardAuto, setForwardAuto ] = useState(null)
    const [ activeRun, setActiveRun ] = useState({
    state: 'ready'
    });
    

    
    

    const clear = () => {
        console.log('clear')
        setChat(chatDef);
        setMessages([]);
    }

    const loadMoreMessages = async (last_id) => {
        if (!chat.activeThread) return;

        setMessages(prev => {
            const newPrev = prev.filter(item => item.id !== 'has_more')
            return newPrev
        });

        const _messages = await fetchMessages(chat.activeThread.id, {after: last_id});
        console.log('get messages', _messages.body)
        if (_messages.body.has_more){
            setMessages(prev => {
                const newPrev = [...prev, ..._messages.data, {id: 'has_more', last_id: _messages.body.last_id, role: 'system'}]
                console.log( 'messagessssssssssss', newPrev )
                return newPrev
            })
        }else{
            setMessages(prev => [...prev, ..._messages.data])
        }
    }
    // useEffect(() => {
    //     if (!chat.activeThread) return;
    //     const fetch = async () => {
    //         const _messages = await fetchMessages(chat.activeThread.id);
    //         setMessages(_messages.data)
    //     }
    //     fetch()
    // }, [chat])

    const fetchAssistant = async (assistant_id) => {
        const myAssistant = await openai.beta.assistants.retrieve(
            assistant_id
          );
          console.log('assistant', myAssistant)
          return myAssistant;
    };

    const fetchMessages = async (thread_id, dict) => {
        console.log('fetchMessages thread_id:', thread_id)
        const myMessages = await openai.beta.threads.messages.list(
            thread_id,
            dict
        );
        setThreadMessages(myMessages);
        console.log('messages', myMessages)
        return myMessages;
    };

    const fetchMessage = async (thread_id, message_id) => {
        const myMessage = await openai.beta.threads.messages.retrieve(
            thread_id,
            message_id
        );
        console.log('message', myMessage)
        return myMessage;
    };

    const fetchThread = async (thread_id) => {
        if (!thread_id || thread_id === '' || thread_id === undefined) return;
        try{
            const myThread = await openai.beta.threads.retrieve(
                thread_id
            );
            return myThread;
        }catch (error){
            console.error(error)
            await sendTask('delete_thread', { thread_id: thread_id })

            return null
        }
        

    };

    const createThread = async (dict) => {
        console.time('createThread')
        const myThread = await openai.beta.threads.create(dict);
        setChat(prev => ({...prev, activeThread: myThread, threads: [ ...prev.threads, myThread ]}))
        await sendTask('add_thread', { thread_id: myThread.id })
        console.timeEnd('createThread')
        return myThread;
    };

    const fetchUpdateThread = async (dict) => {
        if (!run.thread) return;
        console.log('fetchUpdateThread')
        const myThread = await openai.beta.threads.update(
            run.thread.id,
            {metadata:{...run.thread.metadata, ...dict}}
        );
        setRun({...run, thread: myThread})
        console.log('thread', myThread)
        return myThread;
    };

    const fetch_thread_delete = async (thread_id) => {
        if(chat.activeThread.id === thread_id) {
            setMessages([])
            const linearThread = chat.threads.find(item => { return item.metadata.type === 'linear' })
            console.log('linearThread', linearThread)
            if (linearThread){
                const _messages = await fetchMessages(linearThread.id);
                setChat(prev => ({...prev, 
                    activeThread: linearThread, 
                    threads: prev.threads.filter(item => item.id !== thread_id)}))
                setMessages(_messages.data) 
            }
        }else{
            setChat(prev => ({...prev, 
                threads: prev.threads.filter(item => item.id !== thread_id)}))
        }
        console.log('fetch_thread_delete', thread_id)
        openai.beta.threads.del(
            thread_id
        );
        sendTask('delete_thread', { thread_id: thread_id })
    };

    const fetch_image = async (content) => {
        console.log('fetch_title', content )
        if (!content || content === '') return;
        
        const event = z.object({
            prompt: z.string()
          });
        const completion = await openai.chat.completions.create({
            messages: [{ role: "developer", content: "przygotuj prompt pod generację obrazu na podstawie wiadomości" }, {role: "user", content: content}],
            model: "gpt-4o-mini",
            response_format: zodResponseFormat(event, "prompt"),
            store: true,
        });
        // 1024x1792
        // 1024x1024
        if (!completion.choices[0].message.content) return;
        console.log('completion', completion.choices[0].message.content)
        const image = await openai.images.generate({ model: "dall-e-3", prompt: completion.choices[0].message.content, n: 1, size: "1792x1024" });
        const url = image.data[0].url
        console.log('completion', url)
        return url;
    }

    const fetch_title = async (thread_id, content) => {
        if (!content || content === '') return;
        console.log('fetch_title', content )
        const TitleEvent = z.object({
            title: z.string()
          });
        const completion = await openai.chat.completions.create({
            messages: [{ role: "developer", content: "przygotuj krótkie jednozdaniowe (title) na podstawie wiadomości użytkownika" }, {role: "user", content: content}],
            model: "gpt-4o-mini",
            response_format: zodResponseFormat(TitleEvent, "title"),
            store: true,
        });
        const result = JSON.parse(completion.choices[0].message.content);
        await updateThreads(thread_id, {name: result.title})
        console.log('completion', result)
        return result;
    }

    const updateMessage = async (thread_id, msg_id, last_metadata, metadata) => {
        const message = await openai.beta.threads.messages.update(
            thread_id,
            msg_id,
            {
              metadata: {...last_metadata, ...metadata}
            }
        )
        return message;
    }

    const updateThreads = async (thread_id, metadata={}) => {
        let thread = chat.threads > 0 ? chat.threads.find(item => item.id === thread_id) : null;
        if (!thread){
            thread = await fetchThread(thread_id);
        }
        if (thread.metadata.type === 'linear'){
            console.log('update linear Thread')
            
            const updatedThread = await openai.beta.threads.update(
                thread.id,
                {metadata: {...thread.metadata, ...metadata}}
            );

            setChat(prev => {
                return { ...prev,
                    activeThread: updatedThread,
                    linearThread: updatedThread
                }
            });
            
        }else{
            console.log('update  Thread')
            const myThread = await openai.beta.threads.update(
                thread.id,
                { metadata: { ...thread.metadata, ...metadata } }
              );
            setChat(prev => {
                // Tworzymy kopię poprzednich wątków
                const newThreads = [...prev.threads];
                
                // Znajdujemy indeks wątku do aktualizacji
                const index = newThreads.findIndex(t => t.id === myThread.id);
                
                // Aktualizujemy wątek
                if (index !== -1) {
                    newThreads[index] = myThread;
                }
            
                // Zwracamy nowy obiekt stanu
                return {
                    ...prev, // zachowujemy stare wartości
                    threads: newThreads, // aktualizujemy wątki
                    activeThread: myThread // ustawiamy aktywny wątek
                };
            });
            
        }


            
        
        // if (new_thread) add_thread(thread, metadata)
        // Teraz zaktualizuj stan chat
        // setChat(prevChat => ({
        //     ...prevChat,
        //     threads: updatedThreads // Ustaw nową tablicę z aktualizowanymi wątkami
        // }));

      };

    const value={ 
        openai,
        config,
        clear,
        messages, setMessages,
        activeRun, setActiveRun,
        forwardAuto, setForwardAuto,
        stream, setStream,
        chat, setChat,
        fetchThread,
        fetchAssistant,
        fetchUpdateThread,
        fetchMessages,
        fetchMessage,
        fetch_title,
        fetch_image,
        createThread,
        updateThreads,
        fetch_thread_delete,
        loadMoreMessages,
        updateMessage,
    }

    return (
        <OpenAiContext.Provider value={value}>
            { children }
        </OpenAiContext.Provider>
    );
}